import {
    Box,
    Button,
    Card,
} from '@mui/material';
import { FC, useMemo, useState } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { getConfigs } from '../../../configs';
import { API_SLUGS } from '../../../constants';
import { Plus } from '../../../icons/plus';
import { axiosInstance } from '../../../services/axios';
import ModalWrapper from '../../common/modal/wrapper';
import AddPlatformKeyForm from '../AddPlatformKeys/AddPlatformKeyForm';
import MaterialReactTable from 'material-react-table';
import useFetch from '../../../hooks/http/useFetch';
import { IAlertState, useAlertState } from '../../../store/alertState';
import { displayDateTime } from '../../../utils/conversions';
var format = require("string-template")

const ResultsTable: FC<RouteComponentProps> = ({ history, match }) => {
    const { setMessage } = useAlertState((state) => state) as IAlertState;
    const [filter, setFilter] = useState({ "Search On": "", "Search String": "" } as any);
    const path = `${getConfigs().baseApiUrl}/user/accesstokens`;
    const {
        data: accessTokensData,
        loading,
        fetchData,
    } = useFetch(path);
    const acsessTokens = useMemo(
        () => accessTokensData?.accessTokens || [],
        [accessTokensData]
    );
    const revokePlatformKey = async (id: string) => {
        console.log({ id })
        try {
            await axiosInstance.delete(format(API_SLUGS.REVOKE_PLATFORM_KEY, { id: id }));
            fetchData();
            setMessage({
                title: "Key has been revoked",
                type: "success",
            });
        } catch (error: any) {

        }

    };

    return (<Card elevation={0} sx={{ textAlign: "left" }}>
        <Box sx={{ ml: 1 }}>
            <ModalWrapper
                maxWidth="md"
                title="Add Platform Key"
                trigger={<Button variant="contained" sx={{ mb: 2 }}>Add <Plus /></Button>}
                child={<AddPlatformKeyForm />}
                onClose={
                    () => fetchData()
                }
            />

        </Box>
        <MaterialReactTable muiTablePaperProps={{
                elevation: 0
            }} enableGlobalFilter={false}
                columns={[

                    {
                        accessorKey: "name",
                        header: "Name",

                        size: 130,

                    },
                    {
                        accessorKey: "expiresAt",
                        header: "Expires At",
                        Cell: (params: any) => (<>
                            {displayDateTime(params?.row?.original?.expiresAt)}
                        </>)

                    },
                    {
                        accessorKey: "revoke",

                        header: "Revoke",
                        Cell: (params: any) => (
                            <Button onClick={() => revokePlatformKey(params?.row?.original?.id)}>Revoke</Button>
                        ),
                    },
                ]}
                data={acsessTokens}
                initialState={{
                    density: "compact",
                }}
                enableColumnActions={false}
                enableSorting={false}
                enableStickyHeader

                enableBottomToolbar={false}


                enablePagination={false}
                enableDensityToggle={false}
                enableColumnFilters={false}
                // enableRowVirtualization
                state={{
                    showProgressBars: loading,
                }}
            />

    </Card >
    )
};

export default withRouter(ResultsTable);
